import { useEffect, useState } from 'react';
import { apiFetch, useAuthStore } from '@/stores/authStore';

export interface DeskOrderNotice { id:string; orderId:string; actorName:string|null; ticker:string; quantity:string; own:boolean; createdAt:string }
/** Read-only projection of committed cancellation receipts, scoped to the viewer. */
export function useDeskOrderNotices(tickers: string[]): DeskOrderNotice[] {
  const identity=useAuthStore(s=>`${s.user?.id ?? ''}:${s.user?.orgId ?? ''}`);
  const key=JSON.stringify([identity,[...new Set(tickers)].sort()]);
  const [state,setState]=useState<{key:string;rows:DeskOrderNotice[]}>({key:'',rows:[]});
  useEffect(()=>{
    if(identity===':' || tickers.length===0) return;
    let disposed=false, busy=false;
    const load=async()=>{
      if(busy || document.visibilityState==='hidden') return;
      busy=true;
      try {
        const response=await apiFetch('/api/kalshi/desk-order-notices');
        if(!response.ok) return;
        const body=await response.json() as {notices:DeskOrderNotice[]};
        if(!disposed) setState({key,rows:body.notices.filter(n=>tickers.includes(n.ticker))});
      } catch { /* Keep known receipts; the next read may recover. */ }
      finally { busy=false; }
    };
    void load();
    const timer=setInterval(()=>void load(),15_000);
    document.addEventListener('visibilitychange',load);
    return ()=>{ disposed=true; clearInterval(timer); document.removeEventListener('visibilitychange',load); };
    // key contains the complete identity and ticker set.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[key]);
  return state.key===key ? state.rows : [];
}
